import { render, staticRenderFns } from "./Wealth.vue?vue&type=template&id=7ee94c40&scoped=true&"
import script from "./Wealth.vue?vue&type=script&lang=js&"
export * from "./Wealth.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ee94c40",
  null
  
)

export default component.exports